import NataATDefinition from './NataATDefinition'
export default NataATDefinition